// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".32efab66e15a56a92657c50c769c075726c4434a.chunk.js";
};